// Eval-stack mode (REACT_APP_USE_EMULATORS=true).
//
// When set, Firebase talks to local emulators (see firebase.js) and every
// third-party service that would "phone home" is disabled or stubbed here:
// Stripe.js, EmailJS, reCAPTCHA, OpenReplay and Firebase Analytics. Remote
// Config is not fetched, so its local defaults apply.
//
// The check MUST stay a literal `process.env.REACT_APP_USE_EMULATORS === 'true'`
// so the build substitutes it. When unset, every export below is a thin
// pass-through to the real implementation (no behavior change).
import { logEvent as firebaseLogEvent } from "firebase/analytics";

export const isEmulatorMode = process.env.REACT_APP_USE_EMULATORS === 'true';

// Firebase Analytics logEvent; no-op in emulator mode (analytics instance is null there).
export const logEvent = (...args) => {
  if (isEmulatorMode) return undefined;
  return firebaseLogEvent(...args);
};

// reCAPTCHA / Stripe.js: nothing to stub as code. react-google-recaptcha is imported in
// supportWidget.tsx but never rendered (its script only loads on render), and Stripe is
// reached only via the Stripe Pricing Table script tag and the checkout/portal helpers
// in stripe.tsx, which each check `isEmulatorMode` directly.

// EmailJS: init/send stubs; `send` resolves immediately without a network call.
export const emailjsGuarded = (emailjs) =>
  isEmulatorMode
    ? {
        init: () => undefined,
        send: async () => ({ status: 200, text: "OK (eval stub)" }),
        sendForm: async () => ({ status: 200, text: "OK (eval stub)" }),
      }
    : emailjs;
